import type { FTLQuoteRequestForm } from "../../create-ftl-quote.tsx";
import { ShipmentDetails } from "./shipment-details/shipment-details.tsx";

type RateTenderDetailsStepProps = {
	rate: number | null | undefined;
	submittedFormData: FTLQuoteRequestForm | null;
	transitDays: number | null | undefined;
	onShipmentTendered?: (result: { success: boolean; message?: string }) => void;
};

export function RateTenderDetailsStep({
	rate,
	submittedFormData,
	transitDays,
	onShipmentTendered,
}: Readonly<RateTenderDetailsStepProps>) {
	return (
		<div className={"k-p-2"}>
			<ShipmentDetails
				onShipmentTendered={onShipmentTendered}
				rate={rate}
				submittedQuoteFormData={submittedFormData}
				transitDays={transitDays}
			/>
		</div>
	);
}
